import { useState } from "react";
import FilePath from "../filePath/FilePath";
import DocumentGrid from "../documentGrid/DocumentGrid";
import DocumentsList from "../documentsList/DocumentsList";
import { IDocumentListProps } from "../../../../../@types/components/documentListProps.types";
import generateImageUrl from "../../../../../utils/commonFunctions/imageUrl";
import { DocumnetImageDialog } from "../../../../../@types/components/dialogProps.types";
import { generateFileURL } from "../../../../../utils/commonFunctions/generateFileURL";

const DocumentBucket = ({
	handleChangeFolder,
	documentList,
	path,
	redirectFolder,
	setAllDocumentList,
	setDocumentList
}: IDocumentListProps) => {
	// const folderList
	const [viewStyle, setViewStyle] = useState<"LIST" | "GRID">("LIST");
	const handleChangeStyle = (viewType: "LIST" | "GRID") => {
		setViewStyle(viewType);
	};

	const [imageDialogProps, setImageDialogProps] = useState<DocumnetImageDialog>({
		openDialog: false,
		details: "",
		documentId: "",
		title: "",
		mimeType: "",
		image: undefined,
		handleCloseCallback: () =>
			setImageDialogProps(
				Object.assign({}, imageDialogProps, {
					openDialog: false
				})
			)
	});

	const handleViewImageChange = (data: any) => {
		setImageDialogProps(
			Object.assign({}, imageDialogProps, {
				openDialog: true,
				// image: `http://14.96.189.251:4000/api/v1/file/${branding.logo.filename}`
				image: generateFileURL(data.document_details.document),
				mimeType: data.document_details.document.mimetype,
				details: "N/A",
				documentId: data.document_details._id,
				title: data.document_details.document.originalname
			})
		);
	};

	return (
		<div>
			{/* <Paper> */}
			<FilePath
				path={path}
				handleChangeFolder={handleChangeFolder}
				redirectFolder={redirectFolder}
				viewStyle={viewStyle}
				handleChangeStyle={handleChangeStyle}
			/>
			{viewStyle === "GRID" ? (
				<DocumentGrid
					imageDialogProps={imageDialogProps}
					handleViewImageChange={handleViewImageChange}
					redirectFolder={redirectFolder}
					handleChangeFolder={handleChangeFolder}
					gridData={documentList}
					setDocumentList={setDocumentList}
					setAllDocumentList={setAllDocumentList}
					key={1}
				/>
			) : (
				<DocumentsList
					imageDialogProps={imageDialogProps}
					handleViewImageChange={handleViewImageChange}
					redirectFolder={redirectFolder}
					handleChangeFolder={handleChangeFolder}
					gridData={documentList}
					setDocumentList={setDocumentList}
					setAllDocumentList={setAllDocumentList}
					key={1}
				/>
			)}
			{/* </Paper> */}
		</div>
	);
};

export default DocumentBucket;
